import React from "react";

const CTASection = ({ title, highlight, description, buttonText, buttonLink }) => {

  const colors = {
    gradient1: "#546E7A",
    gradient2: "#9BB2A3",
    accent: "#D7A19E",
    text: "#4A5A64"
  };

  return (
    <section className="py-24 px-6">

      <div
        className="max-w-6xl mx-auto rounded-3xl p-12 md:p-16 flex flex-col md:flex-row items-center justify-between gap-10 shadow-xl"
        style={{
          background: `linear-gradient(135deg, ${colors.gradient1}, ${colors.gradient2})`
        }}
      >

        {/* LEFT CONTENT */}
        <div className="max-w-2xl">

          <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight mb-6">
            {title}{" "}
            <span style={{ color: colors.accent }}>
              {highlight}
            </span>
          </h2>

          <p className="text-white/90 text-lg leading-relaxed">
            {description}
          </p>

        </div>

        {/* BUTTON */}
        <div>

          <a
            href={buttonLink}
            className="inline-block px-10 py-4 rounded-xl font-semibold text-sm transition-all duration-300 hover:scale-105"
            style={{
              backgroundColor: colors.accent,
              color: "#fff"
            }}
          >
            {buttonText}
          </a>

        </div>

      </div>

    </section>
  );
};

export default CTASection;